module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-7-426f57b95d11164ff84deccf596f0bd9.jpeg";